import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { Role } from "../../../Controllers/Types/ContactResponse";
import { businessDataUpdateAPI, contactDeleteAPI, employeePersonalUpdateAPI, employeeRoleUpdateAPI, roleCreateAPI, roleDataGetAPI } from "../../../Api/ContactApi";
import { checkEmail, checkFileImage, checkMobileNumber, checkPhoneNumber, checkRole, checkText } from "../../../Utils/Validator";
import { fetchAllContactAfterEditProfessionalDetails } from "../../../Controllers/Thunks/contactThunks";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import ErrorPage from "../../../Components/ErrorPage";
import EmailSearchDialog from "../EmailSearchDialog";

const ViewSelfEmployeeContact: React.FC = () => {
    const professional = useAppSelector(state => state.contact.selectedProfessional);
    const dispatch = useAppDispatch();

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    const [tab, setTab] = useState<'personal' | 'business' | 'role'>('personal');
    const [loading, setLoading] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    /* *************************  Personal form variables ************************ */
    const [profileImage, setProfileImage] = useState<string | null>();
    const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    /* Personal error massage */
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');
    const [errorFirstName, setErrorFirstName] = useState<string>('');
    const [errorLastName, setErrorLastName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorMoblile, setErrorMoblile] = useState<string>('');
    const [errorLandline, setErrorLandline] = useState<string>('');
    const [errorAddress, setErrorAddress] = useState<string>('');
    const [errorCity, setErrorCity] = useState<string>('');
    const [errorPostCode, setErrorPostCode] = useState<string>('');
    /* *************************  Personal form variables ************************ */

    /* *************************  Business form variables ************************ */

    const [businessName, setBusinessName] = useState<string>('');
    const [businessEmail, setBusinessEmail] = useState<string>('');
    const [businessMobile, setBusinessMobile] = useState<string>('');
    const [businessLandline, setBusinessLandline] = useState<string>('');
    const [businessAddress, setBusinessAddress] = useState<string>('');
    const [businessCity, setBusinessCity] = useState<string>('');
    const [businessPostCode, setBusinessPostCode] = useState<string>('');

    const [errorBusinessName, setErrorBusinessName] = useState<string>('');
    const [errorBusinessEmail, setErrorBusinessEmail] = useState<string>('');
    const [errorBusinessMobile, setErrorBusinessMobile] = useState<string>('');
    const [errorBusinessLandline, setErrorBusinessLandline] = useState<string>('');
    const [errorBusinessAddress, setErrorBusinessAddress] = useState<string>('');
    const [errorBusinessCity, setErrorBusinessCity] = useState<string>('');
    const [errorBusinessPostCode, setErrorBusinessPostCode] = useState<string>('');

    /* *************************  Business form variables ************************ */

    /* **************************  Role form variables *************************/
    //Role list 
    const [roleList, setRoleList] = useState<Role[]>([]);

    const [role, setRole] = useState<Role>({ id: 0, role_name: '' });
    const [roleName, setRoleName] = useState<string>('');
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [errorRoleId, setErrorRoleId] = useState<string>('');
    const [errorRoleName, setErrorRoleName] = useState<string>('');
    const [errorDisplayRoleName, setErrorDisplayRoleName] = useState<string>('');
    /* **************************  Role form variables *************************/

    const [showSearchSelfEmpEmailModal, setShowSearchSelfEmpEmailModal] = useState<boolean>(false);


    const [isDefaultProfileImage, setIsDefaultProfileImage] = useState<boolean>(false);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAdd = useCanEdit('Contact', 'add')
    const isPermissionUpdate = useCanEdit('Contact', 'update')
    const isPermissionDelete = useCanEdit('Contact', 'delete')

    //For image upload/change
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    // 

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setProfileImageFile(null);
    };
    // 

    /* **************************** clear All error massage *************************** */
    const clearAllErrorMassage = () => {

        setErrorRoleId('');
        setErrorDisplayRoleName('');


        setErrorProfileImageFile('');
        setErrorFirstName('');
        setErrorLastName('');
        setErrorEmail('');
        setErrorMoblile('');
        setErrorLandline('');
        setErrorAddress('');
        setErrorCity('');
        setErrorPostCode('');


        setErrorBusinessName('');
        setErrorBusinessEmail('');
        setErrorBusinessMobile('');
        setErrorBusinessLandline('');
        setErrorBusinessAddress('');
        setErrorBusinessCity('');
        setErrorBusinessPostCode('');

    };
    /* **************************** clear All error massage *************************** */

    /* ************** API Error massage show ****************** */
    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setErrorEmail(error);
        }
        if (keyName === "mobile") {
            setErrorMoblile(error);
        }
        if (keyName === "landline") {
            setErrorLandline(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }
    }
    function showAPIErrorBusinessData(keyName: string, error: string): void {

        if (keyName === "business_email") {
            setErrorBusinessEmail(error);
        }
        if (keyName === "business_phone") {
            setErrorBusinessMobile(error);
        }
        if (keyName === "business_landline") {
            setErrorBusinessLandline(error);
        }
    }
    /* ************** API Error massage show ****************** */

    /* **************************** role data get *************************** */
    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(data.data || []);
        }
    }
    /* **************************** role data get *************************** */

    /* **************************** Role name create - start *************************** */
    const handleSaveRoleName = async (e: React.FormEvent) => {
        e.preventDefault();

        setErrorRoleName('');
        if (checkCredentialsRoleCreate()) {
            const data = await roleCreateAPI(roleName, localStorage.getItem('token') || '');

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setErrorRoleName(value[0])
                    ))
                }
            } else {
                /* clear data */
                setRoleName('');
                setShowAddData(false);
                /* call call data function */
                roleDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role created successfully.',
                        life: 3000
                    });
                }
            }
        }
    }

    function checkCredentialsRoleCreate(): boolean {
        const isRoleNameValid = checkText(roleName, true, setErrorRoleName);

        return isRoleNameValid;
    }
    /* **************************** Role name create - end *************************** */

    /* **************************** For Update Personal Details - start *************************** */
    const handleUpdatePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();
        if (checkCredentialsPersonalDetails()) {
            setLoading(true);
            const data = await employeePersonalUpdateAPI(Number(professional?.id), firstName, lastName, email, mobile, landline, address, city, postCode, profileImageFile!);
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorPersonalData(key, value[0])
                    ))
                }
            } else {

                dispatch(fetchAllContactAfterEditProfessionalDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Personal details updated successfully.',
                        life: 3000
                    });
                }
                setShowEditModal(false);

                goToTop();
                clearImage();
            }

        } else {

        }

    }

    function checkCredentialsPersonalDetails(): boolean {
        const isEmailValid = checkEmail(email, true, setErrorEmail);
        const isFirstNameValid = checkText(firstName, true, setErrorFirstName);
        const isLastNameValid = checkText(lastName, true, setErrorLastName);
        const isMobileValid = checkMobileNumber(mobile, true, setErrorMoblile);
        const isLandlineNumberValid = checkMobileNumber(landline, false, setErrorLandline);
        const isAddressValid = checkText(address, true, setErrorAddress);
        const isCityValid = checkText(city, true, setErrorCity);
        const isPostCodeValid = checkText(postCode, true, setErrorPostCode);
        const isFileValid = checkFileImage(profileImageFile!, false, setErrorProfileImageFile);

        return isEmailValid && isFirstNameValid && isLastNameValid && isMobileValid && isLandlineNumberValid && isAddressValid && isCityValid && isPostCodeValid && isFileValid;
    }
    /* **************************** For Update Personal Details - end *************************** */

    /* **************************** For Update Business Details - start *************************** */
    const handleUpdateBusinessDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsBusinessData()) {
            setLoading(true);
            const data = await businessDataUpdateAPI(Number(professional?.business_id), businessName, businessEmail, businessMobile, businessLandline, businessAddress, businessCity, businessPostCode);
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorBusinessData(key, value[0])
                    ))
                }
            } else {
                dispatch(fetchAllContactAfterEditProfessionalDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Business details updated successfully.',
                        life: 3000
                    });
                }

                setShowEditModal(false);

                goToTop();
            }
        } else {
        }
    }

    function checkCredentialsBusinessData() {

        const isBusinessEmailValid = checkEmail(businessEmail, false, setErrorBusinessEmail);
        const isBusinessMobileValid = checkPhoneNumber(businessMobile, false, setErrorBusinessMobile);
        const isBusinessLandlineValid = checkPhoneNumber(businessLandline, false, setErrorBusinessLandline);

        return isBusinessEmailValid && isBusinessMobileValid && isBusinessLandlineValid;
    }
    /* **************************** For Update Business Details - end *************************** */


    /* **************************** For Update Role Details - start *************************** */
    const handleUpdateRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRoleInfo()) {
            setLoading(true);
            const data = await employeeRoleUpdateAPI(Number(professional?.user_role_info_id), Number(role.id), displayRoleName);
            setLoading(false);

            if (data.status) { // ture
                dispatch(fetchAllContactAfterEditProfessionalDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role details updated successfully.',
                        life: 3000
                    });
                }
                setShowEditModal(false);

                goToTop();
            } else {
            }
        } else {

        }
    }

    function checkCredentialsRoleInfo(): boolean {
        const isRoleValid = checkRole(role, true, setErrorRoleId);
        const isDisplayRoleNameValid = checkText(displayRoleName, true, setErrorDisplayRoleName);

        return isRoleValid && isDisplayRoleNameValid;
    }
    /* **************************** For Update Role Details - end *************************** */

    /* **************************** for Delete contact - start *************************** */
    const handleDeleteContact = async (e: React.FormEvent) => {
        confirmDialog({
            message: 'Are you sure you want to delete the self employee details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: deleteContact,
        });
    };

    const deleteContact = async () => {

        const res = await contactDeleteAPI(professional!.contactId);

        if (res.status) {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Data deleted successfully.',
                    life: 3000
                });
            }
            setShowEditModal(false);

            setTimeout(() => {
                navigate('/contact');
            }, 500);

        } else {
            if (res.statusCode === 422) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Data deleted failed.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* **************************** for Delete contact - end *************************** */

    ///////////////////// For Role /////////////////////
    // For showing selected role
    const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option.role_name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    // For showing role options in the dropdown list
    const roleOptionTemplate = (option: Role) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.role_name}</div>
            </div>
        );
    };

    /////////////////////////////////////////////////////


    const switchTabs = (tab: 'personal' | 'business' | 'role') => {
        setTab(tab);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    useEffect(() => {
        roleDataGet();

        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    useEffect(() => {
        if (professional) {
            setProfileImage(professional.profile_image);
            setFirstName(professional.first_name);
            setLastName(professional.last_name);
            setEmail(professional.email);
            setMobile(professional.mobile);
            setLandline(professional.landline);
            setAddress(professional.address);
            setCity(professional.city);
            setPostCode(professional.post_code);

            setBusinessName(professional.business_name);
            setBusinessEmail(professional.business_email);
            setBusinessMobile(professional.business_phone);
            setBusinessLandline(professional.business_landline);
            setBusinessAddress(professional.business_address);
            setBusinessCity(professional.business_city);
            setBusinessPostCode(professional.business_post_code);

            setRole({ id: Number(professional.user_role_id), role_name: professional.role_name });
            setDisplayRoleName(professional.display_role_name);

            if (professional?.profile_image) {
                const fileName = professional?.profile_image.split('/').pop();

                if (fileName === 'user.png') {
                    setIsDefaultProfileImage(true);
                } else {
                    setIsDefaultProfileImage(false);
                }
            } else {
                setIsDefaultProfileImage(false);
            }
        }
    }, [professional]);


    /* Edit modal component */
    const editModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {tab === 'personal' ?
                    "Edit Personal detail" :
                    tab === 'business' ?
                        "Edit Business detail" :
                        tab === 'role' ?
                            "Edit Role detail" :
                            null
                }
            </h5>
            {isPermissionDelete && <button type="button" className="data_delete_btn p-ripple"
                onClick={handleDeleteContact}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>}
        </div>
    );

    const editModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowEditModal(false)} />
            {tab === 'personal' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdatePersonalDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'business' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateBusinessDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'role' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateRoleDetails} loading={loading} className="custom_btn primary" />
            ) :
                null
            }
        </div>
    );

    const onEmailConfirmSelfEmployee = (email: string) => {
        setEmail(email);
    }
    /* */

    /* Clear validation messages */
    // Personal
    useEffect(() => {
        checkEmail(email, false, setErrorEmail);
    }, [email]);

    useEffect(() => {
        checkText(firstName, false, setErrorFirstName);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setErrorLastName);
    }, [lastName]);

    useEffect(() => {
        checkMobileNumber(mobile, false, setErrorMoblile);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setErrorLandline);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setErrorAddress);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setErrorCity);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setErrorPostCode);
    }, [postCode]);

    useEffect(() => {
        checkFileImage(profileImageFile!, false, setErrorProfileImageFile);
    }, [profileImageFile]);

    // Business
    useEffect(() => {
        checkEmail(businessEmail, false, setErrorBusinessEmail);
    }, [businessEmail]);

    useEffect(() => {
        checkPhoneNumber(businessMobile, false, setErrorBusinessMobile);
    }, [businessMobile]);

    useEffect(() => {
        checkPhoneNumber(businessLandline, false, setErrorBusinessLandline);
    }, [businessLandline]);

    // Role
    useEffect(() => {
        checkRole(role, false, setErrorRoleId);
    }, [role]);

    useEffect(() => {
        checkText(displayRoleName, false, setErrorDisplayRoleName);
    }, [displayRoleName]);
    //
    /*  */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(!professional) ? (
                    <ErrorPage
                        errorMessage="There was an error retrieving the selected employee details."
                    />
                ) : (
                    <React.Fragment>
                        <div className="main_head_area">
                            <h4 className="main_heading">View Contact</h4>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_label_area">
                            <h6>Self Employee</h6>
                        </div>

                        <div className="page_content mt-0">
                            <div className="page_body_area mt-3">
                                <div className="row">
                                    <div className="col-12 col-xl-4 mx-auto page_divider custom_height" style={{ minHeight }}>
                                        <div className="profile_view_area mt-2 mt-sm-0 mb-4 mb-sm-0">
                                            <div className="profile_view_main_area">
                                                <Image
                                                    className="profile_img_area"
                                                    src={professional?.profile_image ?? ''}
                                                    alt="Profile"
                                                    preview={!isDefaultProfileImage}
                                                />

                                                <h5 className="profile_name text_purple">
                                                    {(professional?.first_name || professional?.last_name)
                                                        ? `${professional?.first_name ?? ''} ${professional?.last_name ?? ''}`.trim()
                                                        : ''
                                                    }
                                                </h5>
                                                <h6 className="profile_role">{professional.role_name}</h6>
                                            </div>

                                            <div className="profile_view_tab_area">
                                                <div className="profile_view_tabs" id="profileViewTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'business' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('business')}
                                                        id="business-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#business-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="business-detail"
                                                        aria-selected={tab === 'business'}
                                                    >
                                                        Business
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('role')}
                                                        id="role-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#role-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="role-detail"
                                                        aria-selected={tab === 'role'}
                                                    >
                                                        Role
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_view_area">
                                            {isPermissionUpdate && (
                                                <button className="profile_edit_btn main p-ripple" onClick={() => setShowEditModal(true)}>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <Ripple />
                                                </button>
                                            )}

                                            <div className="tab-content profile_view_tab_content" id="profileViewTabContent">
                                                {/* Personal Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'personal' ? 'show active' : ''}`} id="personal-detail" role="tabpanel" aria-labelledby="personal-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">First name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.first_name ? (
                                                                        <p>{professional.first_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">First name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Last name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.last_name ? (
                                                                        <p>{professional.last_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Last name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Email</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.email ? (
                                                                        <Link
                                                                            to={`mailto:${professional?.email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {professional.email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Mobile</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.mobile ? (
                                                                        <Link
                                                                            to={`tel:${professional.mobile}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.mobile}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Mobile</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Landline</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.landline ? (
                                                                        <Link
                                                                            to={`tel:${professional.landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.address ? (
                                                                        <p>{professional.address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.city ? (
                                                                        <p>{professional.city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.post_code ? (
                                                                        <p>{professional.post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Business Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'business' ? 'show active' : ''}`} id="business-detail" role="tabpanel" aria-labelledby="business-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Business name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Business name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_name ? (
                                                                        <p>{professional.business_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Business name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Business Email id */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Business Email</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_email ? (
                                                                        <Link
                                                                            to={`mailto:${professional?.business_email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {professional.business_email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Business Email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Business mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Business mobile</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_phone ? (
                                                                        <Link
                                                                            to={`tel:${professional.business_phone}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.business_phone}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Business mobile</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Business landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Business landline</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.landline ? (
                                                                        <Link
                                                                            to={`tel:${professional.landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Business landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Business address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Business address</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_address ? (
                                                                        <p>{professional.business_address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Business address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_city ? (
                                                                        <p>{professional.business_city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.business_post_code ? (
                                                                        <p>{professional.business_post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Role Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'role' ? 'show active' : ''}`} id="role-detail" role="tabpanel" aria-labelledby="role-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Role name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.role_name ? (
                                                                        <p>{professional.role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Display role name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.display_role_name ? (
                                                                        <p>{professional.display_role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Display role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact edit modal */}
                        <Dialog header={editModalHeader} headerClassName="custom_modal_header"
                            footer={editModalFooter} visible={showEditModal}
                            className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showEditModal) return; setShowEditModal(false); }}>
                            <div className="custom_modal_body custom">
                                <div className="row">
                                    <div className="col-12 col-xl-4 page_divider">
                                        <div className="profile_edit_area">

                                            {tab === 'personal' ? (
                                                <React.Fragment>
                                                    <div className="form_img_upload_area pt-0">
                                                        <div className="form_img_upload">
                                                            <input
                                                                type="file"
                                                                accept={imageFileExtension}
                                                                className="form_img_upload_input"
                                                                id="profileImage"
                                                                onChange={handleImageChange}
                                                            />
                                                            <div className="form_img_upload_label_area">
                                                                <label
                                                                    htmlFor="profileImage"
                                                                    className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                                    style={{ backgroundImage: profileImage ? `url(${profileImage})` : professional?.profile_image ? `url(${professional?.profile_image})` : '' }}
                                                                >
                                                                    {(!profileImage && professional?.profile_image === null) && (
                                                                        <div className="upload_icon">
                                                                            <i className="bi bi-camera-fill"></i>
                                                                        </div>
                                                                    )}
                                                                </label>

                                                                {(profileImage || professional?.profile_image) && (
                                                                    <label htmlFor="profileImage" className="upload_update_icon">
                                                                        <i className="bi bi-camera-fill"></i>
                                                                    </label>
                                                                )}
                                                            </div>
                                                            {profileImage ? (
                                                                <React.Fragment>
                                                                    <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                                    {profileImageFile && (
                                                                        <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                                    )}
                                                                </React.Fragment>
                                                            ) : professional?.profile_image ? (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            ) : (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {errorProfileImageFile && (
                                                        <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                                    )}
                                                </React.Fragment>
                                            ) : (
                                                <div className="profile_view_main_area mb-4">
                                                    <Image
                                                        className="profile_img_area custom"
                                                        src={professional?.profile_image ?? ''}
                                                        alt="Profile"
                                                        preview={!isDefaultProfileImage}
                                                    />

                                                    <h5 className="profile_name text_purple">
                                                        {(professional?.first_name || professional?.last_name)
                                                            ? `${professional?.first_name ?? ''} ${professional?.last_name ?? ''}`.trim()
                                                            : ''
                                                        }
                                                    </h5>
                                                    <h6 className="profile_role">{professional.role_name}</h6>
                                                </div>
                                            )}

                                            <div className="profile_edit_tab_area">
                                                <div className="profile_view_tabs" id="profileEditTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-edit-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'business' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('business')}
                                                        id="business-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#business-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="business-edit-detail"
                                                        aria-selected={tab === 'business'}
                                                    >
                                                        Business
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('role')}
                                                        id="role-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#role-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="role-edit-detail"
                                                        aria-selected={tab === 'role'}
                                                    >
                                                        Role
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_edit_area edit_form h-100">
                                            <div className="tab-content profile_view_tab_content" id="profileEditTabContent">
                                                {/* Edit Personal detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'personal' ? 'show active' : ''}`}
                                                    id="personal-edit-detail" role="tabpanel" aria-labelledby="personal-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                                <InputText
                                                                    id="firstName"
                                                                    value={firstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="First name"
                                                                />
                                                                {errorFirstName &&
                                                                    <small className="form_error_msg">{errorFirstName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={lastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Last name"
                                                                />

                                                                {errorLastName &&
                                                                    <small className="form_error_msg">{errorLastName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                                <div className="input_search_group">
                                                                    <InputText
                                                                        id="email"
                                                                        value={email}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Email"
                                                                        disabled
                                                                    />

                                                                    {!email ? (
                                                                        <button
                                                                            className="input_grp_btn primary pos_abs p-ripple"
                                                                            onClick={() => setShowSearchSelfEmpEmailModal(true)}>
                                                                            <i className="bi bi-search"></i>
                                                                            <Ripple />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="input_grp_btn danger pos_abs p-ripple"
                                                                            onClick={() => setEmail('')}>
                                                                            <i className="bi bi-x-lg"></i>
                                                                            <Ripple />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {errorEmail &&
                                                                    <small className="form_error_msg">{errorEmail}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="mobile" className="custom_form_label is_required">Mobile</label>
                                                                <InputText
                                                                    id="mobile"
                                                                    value={mobile}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Mobile"
                                                                />

                                                                {errorMoblile &&
                                                                    <small className="form_error_msg">{errorMoblile}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="landline" className="custom_form_label">Landline</label>
                                                                <InputText
                                                                    id="landline"
                                                                    value={landline}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Landline"
                                                                />

                                                                {errorLandline &&
                                                                    <small className="form_error_msg">{errorLandline}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="address" className="custom_form_label is_required">Address</label>
                                                                <InputText
                                                                    id="address"
                                                                    value={address}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Address"
                                                                />

                                                                {errorAddress &&
                                                                    <small className="form_error_msg">{errorAddress}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="city" className="custom_form_label is_required">City</label>
                                                                <InputText
                                                                    id="city"
                                                                    value={city}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City"
                                                                />

                                                                {errorCity &&
                                                                    <small className="form_error_msg">{errorCity}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="postCode" className="custom_form_label is_required">Post code</label>
                                                                <InputText
                                                                    id="postCode"
                                                                    value={postCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Post code"
                                                                />

                                                                {errorPostCode &&
                                                                    <small className="form_error_msg">{errorPostCode}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Business detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'business' ? 'show active' : ''}`}
                                                    id="business-edit-detail" role="tabpanel" aria-labelledby="business-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Business name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessName" className="custom_form_label">Business name</label>
                                                                <InputText
                                                                    id="businessName"
                                                                    value={businessName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Business name"
                                                                />

                                                                {errorBusinessName &&
                                                                    <small className="form_error_msg">{errorBusinessName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Business Email id */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessEmail" className="custom_form_label">Business Email id</label>
                                                                <InputText
                                                                    id="businessEmail"
                                                                    value={businessEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Business Email id"
                                                                />

                                                                {errorBusinessEmail &&
                                                                    <small className="form_error_msg">{errorBusinessEmail}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Business mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessMobile" className="custom_form_label">Business mobile</label>
                                                                <InputText
                                                                    id="businessMobile"
                                                                    value={businessMobile}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessMobile(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Business mobile"
                                                                />

                                                                {errorBusinessMobile &&
                                                                    <small className="form_error_msg">{errorBusinessMobile}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Business landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessLandline" className="custom_form_label">Business landline</label>
                                                                <InputText
                                                                    id="businessLandline"
                                                                    value={businessLandline}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessLandline(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Business landline"
                                                                />

                                                                {errorBusinessLandline &&
                                                                    <small className="form_error_msg">{errorBusinessLandline}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Business address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessAddress" className="custom_form_label">Business address</label>
                                                                <InputText
                                                                    id="businessAddress"
                                                                    value={businessAddress}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Business address"
                                                                />

                                                                {errorBusinessAddress &&
                                                                    <small className="form_error_msg">{errorBusinessAddress}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessCity" className="custom_form_label">City</label>
                                                                <InputText
                                                                    id="businessCity"
                                                                    value={businessCity}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City"
                                                                />

                                                                {errorBusinessCity &&
                                                                    <small className="form_error_msg">{errorBusinessCity}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="businessPostCode" className="custom_form_label">Post code</label>
                                                                <InputText
                                                                    id="businessPostCode"
                                                                    value={businessPostCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBusinessPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Post code"
                                                                />

                                                                {errorBusinessPostCode &&
                                                                    <small className="form_error_msg">{errorBusinessPostCode}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Role detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'role' ? 'show active' : ''}`}
                                                    id="role-edit-detail" role="tabpanel" aria-labelledby="role-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <div className="w-100">
                                                                    <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                    <Dropdown value={role} id="role" onChange={(e: DropdownChangeEvent) => setRole(e.value)}
                                                                        options={roleList} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                                                                        placeholder="Select role" className="form_dropdown w-100" showClear />

                                                                    {errorRoleId &&
                                                                        <small className="form_error_msg">{errorRoleId}</small>
                                                                    }
                                                                </div>

                                                                <div className="add_data_area">
                                                                    <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                        <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                        {showAddData ? (<span>Cancel</span>)
                                                                            : (<span>Add role</span>)
                                                                        }
                                                                        < Ripple />
                                                                    </button>

                                                                    <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                        <InputText
                                                                            id="roleName"
                                                                            value={roleName}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleName(e.target.value)}
                                                                            className="custom_form_input"
                                                                            placeholder="Enter role name"
                                                                        />

                                                                        <Button
                                                                            label="Add"
                                                                            className="ps-4 pe-4"
                                                                            onClick={handleSaveRoleName}
                                                                        />
                                                                    </div>
                                                                    {errorRoleName &&
                                                                        <small className="form_error_msg">{errorRoleName}</small>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                                <InputText
                                                                    id="displayRoleName"
                                                                    value={displayRoleName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Display role name"
                                                                />

                                                                {errorDisplayRoleName &&
                                                                    <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <EmailSearchDialog
                            visible={showSearchSelfEmpEmailModal}
                            contactSubtype="Self Employee"
                            onHide={() => setShowSearchSelfEmpEmailModal(false)}
                            onEmailConfirm={(email) => onEmailConfirmSelfEmployee(email)}
                        />
                        {/*  */}
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    )
}

export default ViewSelfEmployeeContact;